import * as React from "react";
import { Row, Col, Empty } from "antd";
import {
  addDays,
} from "../../shared/Common";
import "./EqActivityTrainingList.scss";

import EqActivityCollapse from "../eqActivityCollapse/EqActivityCollapse";
import { useTranslation } from "react-i18next";
import { EqUiPaymentAccount, IHorseData, ISchoolStudents } from "../../shared/interfaces/ridingCourse/IRidingCourse";
import { IEqUiSelectModel, IGetPopulation } from "../../shared/interfaces/ILocationDto";
import { ICreateEventDto } from "../../shared/interfaces/ICreateEventDto";
import { useRef } from "react";
import { useLocation } from "react-router-dom";
import { IEqEventData, IEqUiProfile } from "../../shared/interfaces/IEqEventDto";
import { IGetSchoolTrainingInfoDto } from "../../shared/interfaces/GetSchoolTrainingInfoDto";
import { ITrainingInfoDto } from "../../shared/interfaces/ITrainingInfoDtos";
import { EqEntityHorse, IStudentHorseList } from "../../shared/interfaces/horse/IHorses";
import { EqUiStudentGroup } from "../../shared/interfaces/IUserGroupDto";
import { GetSchoolStudentsDto } from "../../shared/interfaces/schoolTraining/school";
//testgit

export interface IEqEventSplit {
  today: any;
  tomorrow: any;
  later: any;
}
// export interface IEqEventSplit {
//     today: Array<IEqEventData>;
//     tomorrow: Array<IEqEventData>;
//     later: Array<IEqEventData>;
// }

export interface IEqActivityTrainingList {
  
    //eventList: ICreateEventDto[];
    eventList: ITrainingInfoDto[] | IGetSchoolTrainingInfoDto[] | IEqEventData[];
  creatorUser?: IEqUiProfile;
  areas?: IEqUiSelectModel[];
  weekDays?: IEqUiSelectModel[];
    population?: IGetPopulation[];
  groupPopulation?: IGetPopulation[];
    trainerStudents?: EqUiStudentGroup[];
    studentHorsesList?: IStudentHorseList[];
  removeEventFunc?: (trainingData: any,refund?:any) => void;
  editEventFunc?: (data: any) => void;
  removeAttendeeFunc?: (data: any) => void;
  onCreateOrUpdateActivity?: (data: any, oldData?: any) => void;
    stripeAccountInfo?: EqUiPaymentAccount;

}
const EqActivityTrainingList = ({
  creatorUser,
  areas,
  weekDays,
  population,
  groupPopulation,
  trainerStudents,
  studentHorsesList,
  eventList,
  removeEventFunc,
  editEventFunc,
  removeAttendeeFunc,
  onCreateOrUpdateActivity,
  stripeAccountInfo,
  ...rest
}: IEqActivityTrainingList) => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const trainingRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});
  const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id'); // <-- Get the 'id' from query string

  const [eventData, setEventData] = React.useState({} as IEqEventSplit);

  const options: Intl.DateTimeFormatOptions = {
    weekday: "long", // Correctly typed as "long" | "short" | "narrow" | undefined
    day: "2-digit",  // Correctly typed as "numeric" | "2-digit" | undefined
    month: "short",  // Correctly typed as "numeric" | "2-digit" | "long" | "short" | "narrow" | undefined
    year: "numeric", // Correctly typed as "numeric" | "2-digit" | undefined
};
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const todayTime = today.getTime();

  const tomorrow = new Date();
  tomorrow.setHours(24, 0, 0, 0);
  const tomorrowTime = tomorrow.getTime();

  const dayAfterTomorrow = new Date();
  dayAfterTomorrow.setHours(48, 0, 0, 0);
  const dayAfterTomorrowTime = dayAfterTomorrow.getTime();

  React.useEffect(() => {
    if (id && eventList?.length > 0) {
      // Use a small delay to ensure the DOM is fully rendered
      const timeoutId = setTimeout(() => {
        const trainingElement = trainingRefs.current[id];
        if (trainingElement) {
          // Scroll to the specific training
          trainingElement.scrollIntoView({ behavior: "smooth", block: "center" });

          // Add a temporary highlight effect
          trainingElement.style.border = "2px solid #FF8838"; // Highlight color
          trainingElement.style.transition = "border 0.5s ease";
          trainingElement.style.padding="4px"

          // Remove the highlight after a few seconds
          setTimeout(() => {
            trainingElement.style.border = "none";
          }, 3000); // Highlight duration
        }
      }, 100); // Small delay to ensure DOM rendering

      // Cleanup the timeout to avoid memory leaks
      return () => clearTimeout(timeoutId);
    }
  }, [id, eventList]); // Run this effect when `id` or `eventList` changes


  React.useEffect(() => {
      var formedData = {} as IEqEventSplit;
      let data = eventList as IEqEventData[];
      if (data?.length > 0) {
      // formedData.today=eventList
          formedData.today = data?.filter(
        // (opt: any) => opt.startDate < tomorrowTime && opt.startDate >= todayTime
        (opt: any) => opt.startDate < tomorrowTime 
      );
          formedData.tomorrow = data?.filter(
        (opt: any) =>
          opt.startDate < dayAfterTomorrowTime && opt.startDate >= tomorrowTime
      );
          formedData.later = data?.filter(
        (opt: any) => opt.startDate > dayAfterTomorrowTime
      );
      setEventData(formedData);
    }
    //formedData.today = eventList;
  }, [eventList, areas, weekDays]);

  return (
    <>
      {eventData?.later?.length > 0 ||
      eventData?.tomorrow?.length > 0 ||
      eventData?.today?.length > 0 ? (
        <>
          <div className="eq-el-container">
            <Row>
              <Col flex="auto">
                <h4 className="eq-el-heading">{t("today")}</h4>
              </Col>
              <Col className="eq-el-dateHeading">
                <h5 className="eq-el-date">
                {new Date().toLocaleDateString(t("dateLang"),options as any)}
                </h5>

                <div className="eq-el-date-icon hidden-sm">
                  <span>
                    <img alt="" src="/DateEdit.svg" />
                  </span>
                </div>
              </Col>
            </Row>

            {eventData?.today?.length > 0 ? (
              <>
                {eventData.today.map((item: any, index: number) => (
                  <div
                  key={index}
                    ref={(el) => (trainingRefs.current[item.id] = el)} // Assign ref to each training
                  >
                    <EqActivityCollapse
                      key={index}
                      creatorUser={creatorUser}
                      event={item}
                      areas={areas}
                      weekDays={weekDays}
                      population={population}
                            groupPopulation={groupPopulation}
                      trainerStudents={trainerStudents}
                      studentHorsesList={studentHorsesList}
                      removeEventFunc={removeEventFunc}
                      editEventFunc={editEventFunc}
                      removeAttendeeFunc={removeAttendeeFunc}
                      onCreateOrUpdateActivity={onCreateOrUpdateActivity}
                    stripeAccountInfo={stripeAccountInfo}

                    ></EqActivityCollapse>
                  </div>
                ))}
              </>
            ) : (
              <Row justify="center">
                <Empty description={t("noTrainingsAvailable")} />
              </Row>
            )}
          </div>

          <div className="eq-el-container">
            <Row>
              <Col flex="auto">
                <h4 className="eq-el-heading">{t("tomorrow")}</h4>
              </Col>
              <Col className="eq-el-dateHeading">
                <h5 className="eq-el-date">
                {addDays(new Date(), 1).toLocaleDateString(t("dateLang"), options)}
                </h5>

                <div className="eq-el-date-icon hidden-sm">
                  <span>
                    <img alt="" src="/DateEdit.svg" />
                  </span>
                </div>
              </Col>
            </Row>

            {eventData?.tomorrow?.length > 0 ? (
              <>
                {eventData.tomorrow.map((item: any, index: number) => (
                  // <EqEvent {...{ event: { ...item }, removeEventFunc: removeEventFunc, editEventFunc: editEventFunc, removeAttendeeFunc: removeAttendeeFunc  }} ></EqEvent>
                  <div
                  key={index}
                  ref={(el) => (trainingRefs.current[item.id] = el)} // Assign ref to each training
                
                  >
                  <EqActivityCollapse
                    key={index}
                    creatorUser={creatorUser}
                    event={item}
                    areas={areas}
                    weekDays={weekDays}
                    population={population}
                    groupPopulation={groupPopulation}
                    trainerStudents={trainerStudents}
                    studentHorsesList={studentHorsesList}
                    removeEventFunc={removeEventFunc}
                    editEventFunc={editEventFunc}
                    removeAttendeeFunc={removeAttendeeFunc}
                    onCreateOrUpdateActivity={onCreateOrUpdateActivity}
                    stripeAccountInfo={stripeAccountInfo}

                  ></EqActivityCollapse></div>
                ))}
              </>
            ) : (
              <Row justify="center">
                <Empty description={t("noTrainingsAvailable")} />
              </Row>
            )}
          </div>
          <div className="eq-el-container">
            <h4 className="eq-el-heading">{t("later")}</h4>

            {eventData?.later?.length > 0 ? (
              <>
                {eventData.later.map((item: any, index: number) => (
                  <div
                  key={index}
                  ref={(el) => (trainingRefs.current[item.id] = el)} // Assign ref to each training
                >
                  <EqActivityCollapse
                    key={index}
                    creatorUser={creatorUser}
                    event={item}
                    areas={areas}
                    weekDays={weekDays}
                    population={population}
                    groupPopulation={groupPopulation}
                    trainerStudents={trainerStudents}
                    studentHorsesList={studentHorsesList}
                    removeEventFunc={removeEventFunc}
                    editEventFunc={editEventFunc}
                    removeAttendeeFunc={removeAttendeeFunc}
                    onCreateOrUpdateActivity={onCreateOrUpdateActivity}
                    stripeAccountInfo={stripeAccountInfo}

                  ></EqActivityCollapse>
</div>
                  // <EqEvent {...{ event: { ...item }, removeEventFunc: removeEventFunc, editEventFunc: editEventFunc, removeAttendeeFunc: removeAttendeeFunc }} key={index} ></EqEvent>
                ))}
              </>
            ) : (
              <Row justify="center">
                <Empty description={t("noTrainingsAvailable")} />
              </Row>
            )}
          </div>
        </>
      ) : (
        <div className="eq-el-container">
          <Empty description={t("noTrainingsAvailable")} />
        </div>
      )}
    </>
  );
};
export default EqActivityTrainingList;
